module.exports = __webpack_public_path__ + "img/categorie.7fa9294d.png";